/**
 * 单元格与报表默认值常量。全部取自 BaskReport 内置模板与真实样本实测值，
 * 避免魔法数字散落各处。序列化时缺省字段不输出（引擎取默认），
 * 此处仅用于「需要显式写出默认值」的场景与合并补全。
 */

export const DEFAULTS = {
  // 单元格属性（仅在需要显式补齐时使用）
  left: 'default',
  top: 'default',
  expand: 'none' as const,
  leftPadding: 0,
  rightPadding: 0,
  topPadding: 0,
  bottomPadding: 0,
  rowspan: 1,
  colspan: 1,
  forcePagingBefore: false,
  forcePaging: false,
  pagingRepeatContent: true,
  rowAutoStretch: true,
  columnAutoStretch: true,
  shrinkFontToFill: false,
  align: 'left' as const,
  valign: 'middle' as const,
  forecolor: '#000000',
  bgColor: '#ffffff',
  fontFamily: '微软雅黑',
  fontSize: 10,
  // 边框缺省：细黑实线（表格报表要求四边可见）
  border: {
    style: 'solid' as const,
    width: 1,
    color: '#000000',
  },
  // 行/列
  rowHeight: 26,
  colWidth: 90,
  // 纸张
  paper: 'A4' as const,
  paperWidth: 210,
  paperHeight: 297,
  marginTop: 2.5,
  marginBottom: 2.5,
  marginLeft: 3.2,
  marginRight: 3.2,
  orientation: 'portrait' as const,
  // 设置
  rowLimit: -1,
  splitRowForPaging: false,
  showEmptyCellStyle: true,
} as const;
